import React, { Fragment, useEffect, useState } from "react";
import { useHandlerCDNMultimedia } from "../../../hooks/useHandlerCDNMultimedia";
import { useAppSelector } from "../../../hooks/customReduxHooks";
import { ContainerAllVideos, ContainerVideo, MainVideoContainer, VideoGalleryContainer, } from "./VideoGalleryStyled";
export var VideoGallery = function (_a) {
    var product = _a.product, selected = _a.selected;
    var _b = useState(), multimediaSelected = _b[0], setMultimediaSelected = _b[1];
    var empresaData = useAppSelector(function (state) { var _a; return (_a = state.empresa) === null || _a === void 0 ? void 0 : _a.empresaData; });
    var getVideosFromS3ForArticlesOnly = useHandlerCDNMultimedia().getVideosFromS3ForArticlesOnly;
    useEffect(function () {
        var _a;
        var videos = (_a = product === null || product === void 0 ? void 0 : product.multimedia) === null || _a === void 0 ? void 0 : _a.filter(function (multimedia) { return multimedia.type === "video"; });
        if (selected) {
            setMultimediaSelected(selected);
        }
        else if (videos && videos.length > 0) {
            setMultimediaSelected(videos[0]);
        }
    }, []);
    var selectVideo = function (multimedia) {
        setMultimediaSelected(multimedia);
    };
    return (React.createElement(VideoGalleryContainer, null, multimediaSelected ? (React.createElement(React.Fragment, null,
        React.createElement(MainVideoContainer, null, product.multimedia
            .filter(function (multimedia) { return multimediaSelected.id === multimedia.id; })
            .map(function (multimedia) { return (React.createElement(Fragment, { key: multimedia.id },
            React.createElement(ContainerVideo, null,
                React.createElement("video", { controls: true, autoPlay: true, controlsList: "nodownload" },
                    React.createElement("source", { src: getVideosFromS3ForArticlesOnly({
                            path: multimedia.url,
                            settings: empresaData.configuraciones,
                        }) }))),
            React.createElement("h3", null, "".concat(product.title, " ").concat(product.subtitle)))); })),
        React.createElement(ContainerAllVideos, null, product.multimedia
            .filter(function (multimedia) { return multimedia.type === "video"; })
            .map(function (multimedia) { return (React.createElement("li", { key: multimedia.id, className: multimedia.id === multimediaSelected.id ? "selected" : "" },
            React.createElement("video", { onClick: function () { return selectVideo(multimedia); }, preload: "metadata", controlsList: "nodownload" },
                React.createElement("source", { src: getVideosFromS3ForArticlesOnly({
                        path: multimedia.url,
                        settings: empresaData.configuraciones,
                    }) })))); })))) : (React.createElement("p", null, "No hay videos disponibles"))));
};
